import { WhatsappAccount, WHATSAPP_STATE_LABELS } from '../services/whatsapp-accounts.service';

// Regra de status do número de WhatsApp para as telas da M4 (sequência, modal, agentes) num
// lugar só — as cópias por tela já divergiam nos rótulos. Os rótulos são os da M3
// (WHATSAPP_STATE_LABELS), os mesmos da tela de Integrações.

type AccountLike = Pick<WhatsappAccount, 'status'> & { active?: boolean };

/** Dá para enviar por ele: ativo e com número verificado (pendente e desativado não). */
export function isAccountUsable(account: AccountLike | null | undefined): boolean {
  return !!account && account.active !== false && account.status !== 'pending' && account.status !== 'disabled';
}

/** Token recusado pela Meta: salva, mas nada sai até reconectar. */
export function isAccountBroken(account: AccountLike | null | undefined): boolean {
  return !!account && (account.status === 'token_expired' || account.status === 'permission_denied');
}

export function accountStatusLabel(account: AccountLike): string {
  return WHATSAPP_STATE_LABELS[account.status] || account.status;
}
